// extracted by mini-css-extract-plugin
export var active = "_ag-7";
export var container = "_ag-0";
export var evenWidth = "_ag-4";
export var large = "_ag-5";
export var outlet = "_ag-8";
export var slide = "_ag-2";
export var small = "_ag-6";
export var tab = "_ag-3";
export var tabs = "_ag-1";